// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","wrapper":"Title__wrapper--Zn","title":"Title__title--bA","popup":"Title__popup--Y1","popupHeader":"Title__popupHeader--bg"};